// Import Vue
import Vue from 'vue'
import moment from 'moment'

import Routes from './routes'
import App from './App.vue'
import Router from 'vue-router'
// import {loadPage} from '@/helpers/routing'
import VueCordova from 'vue-cordova'
import conf from './config/config.dev.js'

// before F7 à cause des modal
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import F7
import 'framework7'
import Framework7Vue from 'framework7-vue'

import 'framework7-icons/css/framework7-icons.css'

import 'framework7-icons/fonts/Framework7Icons-Regular.eot'
import 'framework7-icons/fonts/Framework7Icons-Regular.ttf'
import 'framework7-icons/fonts/Framework7Icons-Regular.woff'
import 'framework7-icons/fonts/Framework7Icons-Regular.woff2'

// for development
import 'font-awesome/fonts/fontawesome-webfont.eot'
import 'font-awesome/fonts/fontawesome-webfont.svg'
import 'font-awesome/fonts/fontawesome-webfont.ttf'
import 'font-awesome/fonts/fontawesome-webfont.woff'
import 'font-awesome/fonts/fontawesome-webfont.woff2'
// import 'font-awesome/fonts/fontAwesome.otf'
import 'font-awesome/css/font-awesome.min.css'

// Import F7 iOS Theme Styles
import 'framework7/dist/css/framework7.ios.min.css'
import 'framework7/dist/css/framework7.ios.colors.min.css'
/* OR for Material Theme:
 import Framework7Theme from 'framework7/dist/css/framework7.material.min.css'
 import Framework7ThemeColors from 'framework7/dist/css/framework7.material.colors.min.css'
 */

// Ramda utilities
import VueRamda from 'vue-ramda'

import './main.css'

import VueEngine from './engine/dist/browser/vue-engine'
import VueI18n from 'vue-i18n'
import VueBus from 'vue-bus'
import pdf from 'vue-pdf'
// import base64url from 'base64url'
import VueNotifications from 'vue-notifications'
import Notifications from 'vt-notifications'
import VueEasyToast from 'vue-easy-toast' // https://github.com/noru/vue-easy-toast

import Datepicker from 'vuejs-datepicker'
import dynamicStyleMixin from './mixins/dynamicStyleMixin'
import userStatusMixin from '@//mixins/userStatusMixin.js'
import errorHandlerMixin from '@//mixins/errorHandlerMixin.js'
import VShowSlide from 'v-show-slide'

// [Adrien][#4965] Initilization vue-google-oauth2 : https://www.npmjs.com/package/vue-google-oauth2
import GAuth from 'vue-google-oauth2'
const gauthOption = {
  // Via browser
  clientId: '306231433723-uv5pfcmnrlsgc4cd0d10kipg9ssg4sdu.apps.googleusercontent.com',
  // Via Android
  // clientId: '306231433723-do4nn197sgc9jv8vhu9bdft0phva4ib0.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(GAuth, gauthOption)
Vue.use(VShowSlide)
Vue.use(VueI18n)
Vue.use(VueBus)
Vue.use(VueEngine)
Vue.use(VueCordova)
Vue.use(pdf)
// Vue.use(base64url)
// Init F7 Vue Plugin
Vue.use(Framework7Vue)

Vue.use(VueRamda)

Vue.use(Datepicker)
Vue.mixin(dynamicStyleMixin)
Vue.mixin(userStatusMixin)
Vue.mixin(errorHandlerMixin)

Vue.use(VueEasyToast)
Vue.use(VueNotifications, options)
Vue.use(Notifications)
Vue.use(Router)

Vue.$engine.common.network.setHost(conf.api.host)
Vue.$engine.common.network.setPort(conf.api.port)
Vue.$engine.common.network.setProtocole(conf.api.protocole)

// Widespread Components
import SkeletonLoader from '@/components/common/SkeletonLoader.vue'
Vue.component('skeleton-loader', SkeletonLoader)

/* TLV 18/02/2020
* Pour changer la langue de l'appli, changer la variable localeLangue ci-dessous
*/
let localeLangue = 'fr'
let i18n = new VueI18n({
  locale: localeLangue,
  fallbackLocale: localeLangue,
  messages: {
    'en': require('./locales/' + localeLangue),
    'fr': require('./locales/' + localeLangue)
  }
})

function toast ({title, message, type, timeout, cb}) {
  let className = 'et-info'
  if (type === VueNotifications.types.warn) className = 'et-warn'
  else if (type === VueNotifications.types.error) className = 'et-alert'

  return Vue.toast(message, {
    duration: timeout,
    className,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
    transition: 'slide-up'
  })
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.filter('formatDate', function (value, type = 'L') {
  let format = 'MM-DD-YYYY'
  if (localeLangue === 'fr') {
    format = 'DD-MM-YYYY'
  }
  return moment(value, 'YYYY-MM-DD').format(format)
})

Vue.filter('formatDateTime', function (value, type = 'L') {
  let format = 'MM-DD-YYYY hh:mm:ss a'
  if (localeLangue === 'fr') {
    format = 'DD-MM-YYYY HH:mm:ss'
  }
  return moment(value, 'YYYY-MM-DDThh:mm:ss').format(format)
})

Vue.filter('formatCommaNumber', function (number) {
  return number.replace('.', ',')
})

// Init App for browser dev
// export default Vue.cordova.on('deviceready', () => {
/* eslint-disable no-new, indent */

const vueRouter = new Router({
  mode: 'history',
  routes: Routes
})

Vue.prototype.$forceCompute = function (computedName, forceUpdate /* default: true */) {
  if (this._computedWatchers[computedName]) {
    this._computedWatchers[computedName].run()
    if (forceUpdate || typeof forceUpdate === 'undefined') this.$forceUpdate()
  }
}

// Observable class but events dont happen on 'notify' but on 'resolve'
// class Observable {
//   // Goal of this class: if there are any paramters and functions,
//   // when 'resolve' , for each function, call for each parameter
//   constructor () {
//     this.functions = []
//     this.parameters = []
//   }
//   subscribe (fn) {
//     this.functions.push(fn)
//   }
//   unsubscribe (fn) {
//     this.functions.remove(fn)
//   }
//
//   notify (param) {
//     this.parameters.push(param)
//   }
//
//   // perform all the actions on all observers
//   resolve () {
//     var parameter = {}
//     // Combine parameters to a unique js Object
//     // aka converts [{toto: 'toto'}, {tata: 'tata'}] into {toto: 'toto', tata: 'tata'}
//     this.parameters.forEach((param) => { parameter = Object.assign(parameter, param) })
//     for (var iFn = 0; iFn < this.functions.length; iFn++) {
//         let fn = this.functions[iFn]
//         fn(parameter)
//         // this.parameters.forEach((action) => { fn(action) })
//     }
//     this.parameters = []
//   }
// }

// const routerObservable = new Observable()

// https://stackoverflow.com/questions/8486099/how-do-i-parse-a-url-query-parameters-in-javascript
// function getJsonFromUrl (url) {
//   if (!url) url = location.href
//   var question = url.indexOf('?')
//   var hash = url.indexOf('#')
//   if (hash === -1 && question === -1) return {}
//   if (hash === -1) hash = url.length
//   var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
//   var result = {}
//   query.split('&').forEach(function (part) {
//     if (!part) return
//     part = part.split('+').join(' ') // replace every + with space, regexp-free version
//     var eq = part.indexOf('=')
//     var key = eq > -1 ? part.substr(0, eq) : part
//     var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
//     var from = key.indexOf('[')
//     if (from === -1) result[decodeURIComponent(key)] = val
//     else {
//       var to = key.indexOf(']', from)
//       var index = decodeURIComponent(key.substring(from + 1, to))
//       key = decodeURIComponent(key.substring(0, from))
//       if (!result[key]) result[key] = []
//       if (!index) result[key].push(val)
//       else result[key][index] = val
//     }
//   })
//   return result
// }

// Before changing page add parameters to {{routerObservable: Observable}}
// vueRouter.beforeEach((to, from, next) => {
//   var OTP = getJsonFromUrl(to.fullPath).OTP
//   var email = getJsonFromUrl(to.fullPath).email
//   var ressource = getJsonFromUrl(to.fullPath).ressource
//   var sendDocumentsFromApplication = getJsonFromUrl(to.fullPath).sendDocumentsFromApplication
//
//   if (OTP) {
//     routerObservable.notify({ OTP: OTP })
//   }
//   if (email) {
//     routerObservable.notify({ email: email })
//   }
//   if (ressource) {
//     routerObservable.notify({ ressource: ressource })
//   }
//   if (sendDocumentsFromApplication) {
//     routerObservable.notify({ sendDocumentsFromApplication: sendDocumentsFromApplication })
//   }
// })
var vueApplication = new Vue({
  i18n,
  router: vueRouter, // We dont use the vue router but it is required for the beforeEach event that occurs before the url is changed (aka before page is changed)
  el: '#app',
  template: '<app/>',
  // Init Framework7 by passing parameters here
  framework7: {
    root: '#app',
    /* Uncomment to enable Material theme: */
    // material: true,
    // router: false,
    routes: Routes,
    tapHold: true,
    tapHoldDelay: 750,
    tapHoldPreventClicks: true,
    cache: false,
    animatePages: false,
    swipePanel: false,
    smartSelectOpenIn: 'picker',
    // onPageBeforeInit: function (event, page) {
    //   if (vueApplication !== undefined) {
    //     console.log(vueApplication)
    //   }
    // },
    onPageInit: function (event, page) {
      vueApplication.$$(page.container).addClass('no-swipeback')
      if (vueApplication !== undefined) {
        if (vueApplication.$f7.mainView.history[vueApplication.$f7.mainView.history.length - 2] === '/login/' &&
        vueApplication.$f7.mainView.history[vueApplication.$f7.mainView.history.length - 1] !== '/register/') {
          vueApplication.$$(page.container).addClass('no-swipeback')
        }
        // vueApplication.$$(page).addClass('no-swipeback')
      }
    }
  },
  mounted () {
    document.addEventListener('backbutton', this.onBackButton, false)
    this.$f7.params.swipePanel = false
    this.$f7.params.panelsCloseByOutside = false

    // If email, otp and ressource are in the URL, loadPage RedirectionPageOTP.vue
    // TLV 02/02/20201 : if there are token, and form link, load document send page
    // routerObservable.subscribe((data) => {
    //   console.log('subscribe')
    //   if (data.OTP && data.email && data.ressource) {
    //     loadPage(vueApplication, { url: '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource })
    //   } else if (data.sendDocumentsFromApplication === '1') {
    //     loadPage(vueApplication, { url: '/OTP/' + data.email + '/' + data.OTP + '/noressource' })
    //   }
    // })
  },
  methods: {
    onBackButton () {
      let l = this.$f7.mainView.history.length
      let history = this.$f7.mainView.history
      if (l > 2 &&
          !history[l - 2].includes('login')) {
        this.$f7.mainView.router.back()
      } // TODO : else it should ask for a second tap on back to quit the app
    }
  },
  // Register App Component
  components: {
    app: App
  }
})



// WEBPACK FOOTER //
// ./src/main.js